module.exports = __webpack_public_path__ + "static/media/send_activation_mail.347e4a41.png";